import { twMerge } from 'tailwind-merge'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { api, api_delete } from '../services/api.service'

import DeleteConfirm from '../components/delete-confirm'

import { style } from '../style'
import { SliderField, TextAreaField, TextField } from './fields'
import S3Field from './fields/s3-field'
import FormWrapper from './form-wrapper'

export default function CustomOwnershipForm(props) {
    const params = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    let id = params.id ?? props.id

    const [productData, setProductData] = useState()
    const [userData, setUserData] = useState()
    const [isNewRegistration, setIsNewRegistration] = useState(false)
    const [changedFields, setChangedFields] = useState(new Set())
    const [confirmDelete, setConfirmDelete] = useState(false)

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const isNew = searchParams.get('new') === 'true'
        setIsNewRegistration(isNew)

        api(`${process.env.REACT_APP_API_URL}/app/profile`).then((x) => {
            setUserData(x)
        })
        api(`${process.env.REACT_APP_API_URL}/public/ownership/${id}`).then((x) => {
            setProductData(x.ownership.product)
        })
    }, [location.search])

    const handleCheckboxChange = (field, subField, value, setValues) => {
        setValues((prev) => ({
            ...prev,
            overridePermissions: {
                ...prev.overridePermissions,
                [field]: {
                    ...prev.overridePermissions?.[field],
                    [subField]: value,
                },
            },
        }))
    }

    return (
        <div className='-m-5 sm:m-0'>
            <FormWrapper hideButton={true} url={`app/ownership`} id={id} includeIdInPost={true} {...props} callback={() => (isNewRegistration ? navigate('/') : window.location.reload())}>
                {(values, setValues, submit) => (
                    <div className='-p-5'>
                        {!values.isCustom && (
                            <div className='mt-10'>
                                <div className='text-xl font-medium text-neutral-800'>{productData?.name}</div>
                                <div className='text-neutral-600'>{productData?.brand}</div>
                            </div>
                        )}

                        {values.isCustom && (
                            <div>
                                <TextField required label='Item' value={values?.name?.toLowerCase().includes('your item needs a name') ? '' : values.name} onChange={(val) => setValues((prev) => ({ ...prev, name: val }))}></TextField>
                                {/* <ImageUpload label='Upload a photo' value={values.photo} onChange={(val) => setValues({ ...values, photo: val })}></ImageUpload> */}
                                <S3Field label='Upload a photo' value={values.s3Image} onChange={(val) => setValues((prev) => ({ ...prev, s3Image: val }))} />
                                <TextAreaField label='Description' placeholder='Add a description of your item, you can include any distinguishing features or unique aspects of your item...' value={values.description} onChange={(val) => setValues((prev) => ({ ...prev, description: val }))} />
                            </div>
                        )}

                        <div onClick={() => submit()} className={twMerge('text-white border-none text-center mx-auto my-5', style.button.classname, style.button._secondary.classname)}>
                            Save
                        </div>

                        {!isNewRegistration && (
                            <div>
                                <div className='flex flex-col my-5 space-y-1 text-neutral-700'>
                                    <div className='text-xl font-bold'>Control what finders can see for this item.</div>
                                    <div>The numbers and emails provided here will receive found notifications.</div>
                                    <div>If you'd rather not leave your contact details, that's ok! Finders can still send you an email via Boomerang with return details.</div>
                                    <div>Visit “Settings” to change what finders can see by default.</div>
                                </div>
                                <div className='flex'>
                                    <div>
                                        <button
                                            className={twMerge(style.button.classname, style.button._secondary.classname)}
                                            type='button'
                                            onClick={() => {
                                                setChangedFields(new Set())
                                                setValues((prev) => ({
                                                    ...prev,
                                                    overridePermissions: {},
                                                    overrideLastName: null,
                                                    overrideName: null,
                                                    customEmail: null,
                                                    customPhoneNumber: null,
                                                    customWhatsappNumber: null,
                                                    returnInstructions: null,
                                                    overrideAllowFinderGPS: undefined,
                                                    overrideAllowMaskedCalls: undefined,
                                                }))
                                            }}
                                        >
                                            Reset to default
                                        </button>
                                    </div>
                                </div>
                                <div className='flex flex-col space-y-10 divide-y'>
                                    {[
                                        { label: 'First Name', field: 'name', overrideField: 'overrideName', mutable: true, isOverride: true },
                                        { label: 'Last Name', field: 'lastName', overrideField: 'overrideLastName', mutable: true, isOverride: true },
                                        { label: 'Email', field: 'email', overrideField: 'customEmail', mutable: true, isOverride: false },
                                        { label: 'Phone Number', field: 'phoneNumber', overrideField: 'customPhoneNumber', mutable: true, isOverride: false },
                                        { label: 'WhatsApp', field: 'whatsappNumber', overrideField: 'customWhatsappNumber', mutable: true, isOverride: false },
                                        { label: 'Return Instructions', field: 'returnInstructions', overrideField: 'returnInstructions', mutable: true, isOverride: false },
                                    ].map(({ label, field, overrideField, mutable, isOverride }) => {
                                        const hasBeenChanged = changedFields.has(overrideField)

                                        let value
                                        if (hasBeenChanged) {
                                            // User has explicitly changed this field, use their exact value (including empty string)
                                            value = values[overrideField] ?? ''
                                        } else {
                                            // Field hasn't been changed, check if there's a saved override value, otherwise use default
                                            const savedValue = values[overrideField]
                                            if (savedValue !== undefined && savedValue !== null && savedValue !== '') {
                                                value = savedValue
                                            } else {
                                                // Show default from userData
                                                value = field === 'returnInstructions' ? userData?.defaultReturnInstructions || '' : userData?.[field] || ''
                                            }
                                        }
                                        return (
                                            <div className='flex space-x-5' key={field}>
                                                <div className='flex-1 text-sm sm:text-base'>
                                                    {mutable ? (
                                                        field !== 'returnInstructions' ? (
                                                            <div>
                                                                <TextField
                                                                    label={label}
                                                                    value={value}
                                                                    placeholder={isOverride ? '' : `Default: ${userData?.[field] || 'Not set'}`}
                                                                    onChange={(val) => {
                                                                        setChangedFields((prev) => new Set(prev).add(overrideField))
                                                                        setValues((prev) => ({ ...prev, [overrideField]: val }))
                                                                    }}
                                                                />
                                                                {['phoneNumber', 'whatsappNumber'].includes(field) && <p className='text-sm text-gray-500'>Mobile numbers should include a country code (e.g. +44)</p>}
                                                                {field === 'whatsappNumber' && (
                                                                    <button
                                                                        type='button'
                                                                        className='px-2 py-1 mt-1 text-xs text-gray-700 bg-gray-100 rounded hover:bg-gray-200'
                                                                        onClick={() => {
                                                                            const phoneValue = values.customPhoneNumber || userData?.phoneNumber
                                                                            setChangedFields((prev) => new Set(prev).add('customWhatsappNumber'))
                                                                            setValues((prev) => ({ ...prev, customWhatsappNumber: phoneValue }))
                                                                        }}
                                                                    >
                                                                        Copy from phone number
                                                                    </button>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <TextAreaField
                                                                placeholder={userData?.defaultReturnInstructions}
                                                                label={'Default return instructions'}
                                                                value={value}
                                                                onChange={(val) => {
                                                                    setChangedFields((prev) => new Set(prev).add('returnInstructions'))
                                                                    setValues((prev) => ({ ...prev, returnInstructions: val }))
                                                                }}
                                                            />
                                                        )
                                                    ) : (
                                                        <div>
                                                            <div>{label}</div>
                                                            <div>{value}</div>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* {field !== "returnInstructions" && <> */}
                                                <div>
                                                    <SliderField label='Show always' value={values.overridePermissions?.[field]?.showAlways !== undefined ? values.overridePermissions?.[field]?.showAlways : userData?.defaultPermissions?.[field]?.showAlways} onChange={(val) => handleCheckboxChange(field, 'showAlways', val, setValues)} />
                                                    <SliderField label='Show when lost' value={values.overridePermissions?.[field]?.showWhenLost !== undefined ? values.overridePermissions?.[field]?.showWhenLost : userData?.defaultPermissions?.[field]?.showWhenLost} onChange={(val) => handleCheckboxChange(field, 'showWhenLost', val, setValues)} />
                                                </div>
                                                {/* </>} */}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )}

                        {/* Family Premium Notification Controls */}
                        {userData?.subscriptionType === 'family_premium' && (userData?.additionalEmails?.length > 0 || userData?.additionalWhatsappNumbers?.length > 0) && (
                            <div className='pt-5 mt-5 border-t'>
                                <div className='mb-3 text-lg font-medium text-neutral-800'>Family Plus Notifications</div>
                                <div className='mb-4 text-sm text-gray-600'>Choose which family contacts will be notified when this item is found.</div>

                                <div className='space-y-4'>
                                    {userData?.additionalEmails?.length > 0 && (
                                        <div>
                                            <h4 className='mb-2 font-medium text-neutral-700'>Email Notifications</h4>
                                            {userData.additionalEmails.map(
                                                (email, index) =>
                                                    email && (
                                                        <div key={`email-notify-${index}`} className='flex items-center mb-2 space-x-2'>
                                                            <input
                                                                type='checkbox'
                                                                id={`notify-email-${index}`}
                                                                checked={values.notifyAdditionalEmails?.[index] !== false}
                                                                onChange={(e) => {
                                                                    const newNotifyEmails = [...(values.notifyAdditionalEmails || [])]
                                                                    newNotifyEmails[index] = e.target.checked
                                                                    setValues((prev) => ({ ...prev, notifyAdditionalEmails: newNotifyEmails }))
                                                                }}
                                                                className='rounded border-gray-300 text-brand-600 focus:ring-brand-500'
                                                            />
                                                            <label htmlFor={`notify-email-${index}`} className='text-sm text-gray-700'>
                                                                {email}
                                                            </label>
                                                        </div>
                                                    )
                                            )}
                                        </div>
                                    )}

                                    {userData?.additionalWhatsappNumbers?.length > 0 && (
                                        <div>
                                            <h4 className='mb-2 font-medium text-neutral-700'>WhatsApp Notifications</h4>
                                            {userData.additionalWhatsappNumbers.map(
                                                (number, index) =>
                                                    number && (
                                                        <div key={`whatsapp-notify-${index}`} className='flex items-center mb-2 space-x-2'>
                                                            <input
                                                                type='checkbox'
                                                                id={`notify-whatsapp-${index}`}
                                                                checked={values.notifyAdditionalWhatsapp?.[index] !== false}
                                                                onChange={(e) => {
                                                                    const newNotifyWhatsapp = [...(values.notifyAdditionalWhatsapp || [])]
                                                                    newNotifyWhatsapp[index] = e.target.checked
                                                                    setValues((prev) => ({ ...prev, notifyAdditionalWhatsapp: newNotifyWhatsapp }))
                                                                }}
                                                                className='rounded border-gray-300 text-brand-600 focus:ring-brand-500'
                                                            />
                                                            <label htmlFor={`notify-whatsapp-${index}`} className='text-sm text-gray-700'>
                                                                {number}
                                                            </label>
                                                        </div>
                                                    )
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Finder Communication Settings */}
                        <div className='pt-5 mt-5 border-t'>
                            <div className='mb-3 text-lg font-medium text-neutral-800'>Finder Communication</div>
                            <div className='mb-4 text-sm text-gray-600'>{userData?.subscriptionType === 'standard' ? 'Upgrade to Plus for GPS location sharing and masked phone calls.' : 'Control how finders can communicate with you for this item.'}</div>

                            <div className='space-y-4'>
                                <div>
                                    <h4 className='mb-2 font-medium text-neutral-700'>Allow finder to share GPS location</h4>
                                    <div className='flex items-center mb-2 space-x-2'>
                                        <input type='checkbox' id='override-gps' checked={values.overrideAllowFinderGPS !== undefined ? values.overrideAllowFinderGPS : userData?.allowFinderGPS !== false} onChange={(e) => setValues((prev) => ({ ...prev, overrideAllowFinderGPS: e.target.checked }))} disabled={userData?.subscriptionType === 'standard'} className='rounded border-gray-300 text-brand-600 focus:ring-brand-500' />
                                        <label htmlFor='override-gps' className='text-sm text-gray-700'>
                                            {values.overrideAllowFinderGPS !== undefined ? (values.overrideAllowFinderGPS ? 'Enabled for this item' : 'Disabled for this item') : `Using default: ${userData?.allowFinderGPS !== false ? 'Enabled' : 'Disabled'}`}
                                        </label>
                                        {values.overrideAllowFinderGPS !== undefined && userData?.subscriptionType !== 'standard' && (
                                            <button type='button' className='ml-2 text-xs text-gray-500 underline hover:text-gray-700' onClick={() => setValues((prev) => ({ ...prev, overrideAllowFinderGPS: undefined }))}>
                                                Reset to default
                                            </button>
                                        )}
                                    </div>
                                </div>

                                <div>
                                    <h4 className='mb-2 font-medium text-neutral-700'>Allow masked phone calls</h4>
                                    <div className='flex items-center mb-2 space-x-2'>
                                        <input type='checkbox' id='override-calls' checked={values.overrideAllowMaskedCalls !== undefined ? values.overrideAllowMaskedCalls : userData?.allowMaskedCalls !== false} onChange={(e) => setValues((prev) => ({ ...prev, overrideAllowMaskedCalls: e.target.checked }))} disabled={userData?.subscriptionType === 'standard'} className='rounded border-gray-300 text-brand-600 focus:ring-brand-500' />
                                        <label htmlFor='override-calls' className='text-sm text-gray-700'>
                                            {values.overrideAllowMaskedCalls !== undefined ? (values.overrideAllowMaskedCalls ? 'Enabled for this item' : 'Disabled for this item') : `Using default: ${userData?.allowMaskedCalls !== false ? 'Enabled' : 'Disabled'}`}
                                        </label>
                                        {values.overrideAllowMaskedCalls !== undefined && userData?.subscriptionType !== 'standard' && (
                                            <button type='button' className='ml-2 text-xs text-gray-500 underline hover:text-gray-700' onClick={() => setValues((prev) => ({ ...prev, overrideAllowMaskedCalls: undefined }))}>
                                                Reset to default
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {userData?.subscriptionType === 'standard' && (
                                    <div className='p-3 bg-blue-50 rounded-md border border-blue-200'>
                                        <p className='text-sm text-blue-800'>
                                            <strong>Plus Benefits:</strong> Upgrade to Plus for GPS location sharing and masked phone calls!
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {!isNewRegistration && (
                            <div onClick={() => submit()} className={twMerge('text-white border-none text-center mx-auto my-5', style.button.classname, style.button._secondary.classname)}>
                                Save
                            </div>
                        )}

                        {values.isCustom && !isNewRegistration && (
                            <button type='button' onClick={() => setConfirmDelete(true)} className={twMerge('border-none text-center mx-auto my-5', style.button.classname, style.button._dark.classname)}>
                                Delete
                            </button>
                        )}
                        <DeleteConfirm
                            open={confirmDelete}
                            confirm={() => {
                                setConfirmDelete(false)
                                api_delete(`${process.env.REACT_APP_API_URL}/app/ownership/${id}`).then((res) => {
                                    if (res.ok) navigate('/')
                                })
                            }}
                            cancel={() => setConfirmDelete(false)}
                        />
                    </div>
                )}
            </FormWrapper>
        </div>
    )
}
